import { graphql } from 'gatsby';
import React from 'react';
import {
  Container,
  Content,
  ContentCard,
  Pagination,
  PersonalInfo,
  SEO,
} from '../components';
import { Header } from '../components/header';
import { OuterBlogWrapper, SideBarWrapper } from '../elements';

const allPosts = ({ pageContext, data }) => {
  const { currentPage, numPages } = pageContext;
  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const prevPage = currentPage - 1 === 1 ? '/' : `/${currentPage - 1}`;
  const nextPage = `${currentPage + 1}`;
  const posts = data.allMdx.edges;

  return (
    <Container>
      <SEO />
      <PersonalInfo />
      <Header />
      <OuterBlogWrapper>
        <SideBarWrapper />
        <Content>
          {posts.map((post, i) => (
            <ContentCard
              key={post.node.frontmatter.slug}
              date={post.node.frontmatter.date}
              title={post.node.frontmatter.title}
              excerpt={post.node.frontmatter.excerpt}
              slug={post.node.frontmatter.slug}
              image={post.node.frontmatter.featureImage}
              author={post.node.frontmatter.author}
              readTime={post.node.frontmatter.readTime}
              tags={post.node.frontmatter.tags}
              extension={post.node.frontmatter.featureImage.extension}
              publicURL={post.node.frontmatter.featureImage.publicURL}
              index={i}
            />
          ))}
        </Content>
        <SideBarWrapper />
      </OuterBlogWrapper>
      <Pagination
        isFirst={isFirst}
        isLast={isLast}
        prevPage={prevPage}
        nextPage={nextPage}
      />
    </Container>
  );
};

export default allPosts;

export const PageQuery = graphql`
  query AllPostsQuery($skip: Int!, $limit: Int!) {
    allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      skip: $skip
      limit: $limit
    ) {
      edges {
        node {
          frontmatter {
            slug
            title
            author
            readTime
            featureImage {
              childImageSharp {
                fixed {
                  ...GatsbyImageSharpFixed
                }
              }
              extension
              publicURL
            }
            date(formatString: "MMMM DD YYYY")
            tags
            excerpt
          }
        }
      }
    }
  }
`;
